import axios from 'axios';
import { Affiliated, RadiationForm } from 'core/models';

interface ApiResponse {
    data: Affiliated[];
    totalPage: number;
    totalResultat: number;
}

export function getAffilies(page, limit, sort, search): Promise<ApiResponse> {
    return axios.get(`/affilie`, {
        params: {
            page,
            limit,
            sort,
            search: search && search.length ? JSON.stringify(search) : undefined,
        },
    });
}
export function getAffiliesPrev(page, limit, sort, search): Promise<ApiResponse> {
    return axios.get(`/affilie/prevoyance`, {
        params: {
            page,
            limit,
            sort,
            search: search && search.length ? JSON.stringify(search) : undefined,
        },
    });
}

export function getAffilie(numSecu: string) {
    return axios.get(`/affilie/${numSecu}`);
}

export function getAffilieContract(codAffilie: string, codContract: string) {
    return axios.get(`/affilie/${codAffilie}/contract/${codContract}`);
}

export function sendRadiationForm(data: RadiationForm) {
    return axios.post(`/affilie/${data.codAffilie}/radiation/${data.codSouscrip}`, data);
}

export function getRadiationData({ codAffilie, codSouscrip }) {
    return axios.get(`/affilie/${codAffilie}/contracts/${codSouscrip}`);
}

export function exportAffiliates(search: object[]) {
    return axios.get<Blob>(`/export_excel/affilies`, {
        params: {
            search: search && search.length ? JSON.stringify(search) : undefined,
        },
        responseType: 'blob',
    });
}

export function getAffiliesWithCompensation(page, limit, sort, search): Promise<ApiResponse> {
    return axios.get(`/affilie/withCompensation`, {
        params: {
            page,
            limit,
            sort,
            search: search && search.length ? JSON.stringify(search) : undefined,
        },
    });
}

export function getCompensationsByAffiliateId(codAffilie: string) {
    return axios.get(`/affilie/${codAffilie}/compensations`);
}

export function getCompensationsById(codAffilie: string, compensationId: string) {
    return axios.get(`affilie/${codAffilie}/compensations/${compensationId}`);
}

export function exportIncapacite(search: object[]) {
    return axios.get<Blob>(`/export_excel/incapacite`, {
        params: {
            search: search && search.length ? JSON.stringify(search) : undefined,
        },
        responseType: 'blob',
    });
}

export function exportPrestationLidl({ startPeriod, endPeriod }) {
    return axios.get<Blob>(`/export_excel/prestation_lidl`, {
        params: { startPeriod: startPeriod, endPeriod: endPeriod },
        responseType: 'blob',
    });
}

export interface PdfCompensationRequest {
    codAffilie: string;
    compensationId: string;
    startPeriod?: string | null;
    endPeriod?: string | null;
}

export function exportPdfCompensationByPeriod({ codAffilie, compensationId, startPeriod = null, endPeriod = null }: PdfCompensationRequest): Promise<Blob> {
    const params = {
        ...(startPeriod !== null && { startPeriod: startPeriod }),
        ...(endPeriod !== null && { endPeriod: endPeriod }),
    };

    return axios.get(`/affilie/${codAffilie}/compensations/${compensationId}/pdf`, {
        params,
        responseType: 'blob',
    });
}


export function exportExcelPrestations(folderId: string) {
    return axios.get<Blob>(`/export_excel/prestations/${folderId}`, {
        params: {},
        responseType: 'blob',
    });
}

export function getHistoryExportAG2R({ page, limit, sort, search }) {
    return axios.get(`export_excel/list_export_AG2R`, {
        params: {
            page,
            limit,
            sort,
            search: search && search.length ? JSON.stringify(search) : undefined,
        },

    });
}
